import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'
import { ContractCreateComponent } from '../../features/contract/contract-create/contract-create.component'
import { ProposalClientService } from '../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../core/services/contract/contract-client/contract-client.service'
import { ScheduleFleetService } from '../../core/services/schedule/schedule-fleet/schedule-fleet.service'
import { ScheduleComponent } from '../../features/schedule/schedule.component'
import { ScheduleSearchComponent } from "./schedule-search/schedule-search.component";
import { FormGroup } from '@angular/forms'
import { TableListFixedComponent } from "../../shared/components/table-list-fixed/table-list-fixed.component";
import { interval } from 'rxjs'
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { TableListScheduleFleetComponent } from "../../shared/components/table-list-schedule-fleet/table-list-schedule-fleet.component";
import { DialogConfirmComponent } from '../../shared/components/dialog-confirm/dialog-confirm.component'
import { SnackbarCustomService } from '../../shared/components/snackbar/snackbar-custom.service'
import { MatTabsModule } from '@angular/material/tabs'
import { PreEscalaFrotaComponent } from './pre-escala-frota/pre-escala-frota.component'
import { ImpedimentosMotoristaComponent } from './impedimentos-motorista/impedimentos-motorista.component'
import { CronogramaMotoristaComponent } from './cronograma-motorista/cronograma-motorista.component'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { finalize } from 'rxjs'
import {
  downloadBlobFile,
  fileNameFromContentDisposition,
  parseBlobError,
} from '../../shared/utils/download_base64'
import moment from 'moment/moment'

@Component({
  selector: 'contract',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    ScheduleSearchComponent,
    TableListFixedComponent,
    MatPaginatorModule,
    TableListScheduleFleetComponent,
    MatTabsModule,
    PreEscalaFrotaComponent,
    ImpedimentosMotoristaComponent,
    CronogramaMotoristaComponent,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinner,
  ],
  templateUrl: './fleet-schedule.component.html',
  styleUrl: './fleet-schedule.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class FleetScheduleComponent implements OnInit {

  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private scheduleFleetService: ScheduleFleetService,
    private serviceOrderService: ServiceOrderService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbarCustomService: SnackbarCustomService,

  ) { }

  form!: FormGroup;
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  inputSearch = ''

  // Último filtro aplicado (form de busca ou o default do createModel()) — usado
  // por paginação e ordenação pra nunca "perder" o filtro ativo, como acontecia
  // antes (paginar caía sempre na listagem sem filtro).
  currentSearchModel: any = null
  sort: { ordenarPor: string; direcao: 'asc' | 'desc' } | null = null

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'os_period_date',
      key: 'os_period_date',
      description: 'Datas',
      sortField: 'data',
    },
    {
      keyColumn: 'os_code',
      key: 'os_code',
      description: 'Códigos',
      sortField: 'codigoOs',
    },
    {
      keyColumn: 'os_client',
      key: 'os_client',
      description: 'Clientes',
      sortField: 'cliente',
    },
    {
      keyColumn: 'os_percusent',
      key: 'os_percusent',
      description: 'Percurso',
    },
    {
      keyColumn: 'os_services',
      key: 'os_services',
      description: 'Serviço',
    },
    {
      keyColumn: 'os_vehicles',
      key: 'os_vehicles',
      description: 'Veículo',
      sortField: 'veiculo',
    },
    {
      keyColumn: 'os_driver',
      key: 'os_driver',
      description: 'Motorista',
      sortField: 'motorista',
    },
    {
      keyColumn: 'valor',
      key: 'valor',
      description: 'Valor',
      sortField: 'valor',
    },
    {
      keyColumn: 'pax',
      key: 'pax',
      description: 'PAX',
      sortField: 'passageiros',
    },
    {
      keyColumn: 'nomeEvento',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'status',
      key: 'descricaoStatus',
      description: 'Status',
      sortField: 'status',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: false, view: true },
      description: 'Ações',
      stickerEnd: true,
      width: '100px'
    },
  ]

  screen = 'status cotação'

  ngOnInit() {
    this.checkColumnAction()
    this.currentSearchModel = this.createModel()
    this.searchFleet(this.currentSearchModel)
    interval(3600000).subscribe(() => {
      this.searchFleet(this.currentSearchModel)
    })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        //edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        edit: true,
        view: true,
        sendToPurchases: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  searchFleet(data: any) {
    this.loading = true
    const model = {
      ...data,
      ordenarPor: this.sort?.ordenarPor,
      direcao: this.sort?.direcao,
    }
    this.scheduleFleetService.searchPagedAgendaFrota(this.page, this.rows, model).subscribe({
      next: (res) => {
        this.treatResponse(res)
        this.loading = false
      },
      error: (err) => {
        this.loading = false
      }
    })
  }

  // Excel da busca inteira (não da página): mesmo corpo do search-paginated, com os
  // filtros e a ordenação da tela. O back recusa com 400 acima de 5000 serviços.
  exportingExcel = false

  exportExcel() {
    if (this.exportingExcel) return
    this.exportingExcel = true
    const model = {
      ...this.currentSearchModel,
      ordenarPor: this.sort?.ordenarPor,
      direcao: this.sort?.direcao,
    }
    this.scheduleFleetService
      .exportarExcelAgendaFrota(model)
      .pipe(finalize(() => (this.exportingExcel = false)))
      .subscribe({
        next: (res) => {
          if (!res.body) return
          downloadBlobFile(
            res.body,
            fileNameFromContentDisposition(
              res.headers.get('Content-Disposition'),
              `AgendaFrota_${moment().format('DD-MM-YYYY_HHmm')}.xlsx`,
            ),
          )
        },
        error: async (err: any) => {
          this.snackbarCustomService.errorRequest(await parseBlobError(err))
        },
      })
  }

  createModel() {
    return {
      dataInicio: '',
      dataFinal: '',
      nomeCliente: '',
      nomeSubCliente: '',
      status: 4,
      descricaoOrigem: '',
      descricaoDestino: '',
      descricaoTipoServico: '',
      servico: '',
      descricaoTipoVeiculo: '',
      descricaoTipoMotorista: '',
      codigoTg: '',
      codigoOs: '',
      estado: '',
      semMotorista: undefined,
      motoristaId: undefined,
    }
  }

  // Paginação sempre reaplica o último filtro ativo (currentSearchModel) — antes,
  // paginar chamava a listagem sem filtro (listPagedAgendaFrota) e o usuário
  // "perdia" a busca que tinha acabado de fazer.
  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.searchFleet(this.currentSearchModel)
  }

  onSort(event: { ordenarPor: string; direcao: 'asc' | 'desc' } | null) {
    this.sort = event
    this.page = 1
    this.searchFleet(this.currentSearchModel)
  }

  listSearch(event: any) {
    if (event == null) {
      this.itemsList = []
      this.numberRows = 0
      this.loading = false
      return
    }
    this.page = 1
    this.currentSearchModel = event === 'reset' ? this.createModel() : event
    this.searchFleet(this.currentSearchModel)
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ContractCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.searchFleet(this.currentSearchModel)
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, viewMode: false }
    })
    dialogRef.componentInstance.responseEdit.subscribe((response: any) => {
      if (response) {
        this.searchFleet(this.currentSearchModel)
      }
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.searchFleet(this.currentSearchModel)
      }
    })
  }

  viewItem(item: any) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, viewMode: true }


    })
    // dialogRef.componentInstance.responseViewEdit.subscribe((response: any) => {
    //   if (response) {
    //     this.searchFleet()
    //   }
    // })
    // dialogRef.afterClosed().subscribe(() => {
    //   this.searchFleet()
    // })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {
  }

  sendToPurchasesItem(item: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Enviar para Compras',
        message: `Deseja enviar a OS ${item.codigoOs} para Compras?`,
        confirmLabel: 'Enviar',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.serviceOrderService
        .transferirResponsavel(item.codigoOs, 'COMPRAS')
        .subscribe({
          next: () => {
            this.snackbarCustomService.success('OS enviada para Compras com sucesso.')
            this.searchFleet(this.currentSearchModel)
          },
          error: (err: any) => {
            this.snackbarCustomService.errorRequest(err)
          },
        })
    })
  }

}
